import { render, staticRenderFns } from "./OgmAlertsVueContainer.vue?vue&type=template&id=e6020fec&scoped=true"
import script from "./OgmAlertsVueContainer.vue?vue&type=script&lang=js"
export * from "./OgmAlertsVueContainer.vue?vue&type=script&lang=js"
import style0 from "./OgmAlertsVueContainer.vue?vue&type=style&index=0&id=e6020fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6020fec",
  null
  
)

export default component.exports